<script setup>
import {updateMe} from "@/helpers/back";
import {useStore} from "@/state/store";
import {useColorModes} from "@coreui/vue";
import {logout} from "@/helpers/back";

import {nowTz, nowUtc, prettyDt, weekNumByDate} from "@/helpers/h";
const store = useStore()
const version = process.env.VUE_APP_VERSION
const { colorMode, setColorMode } = useColorModes('coreui-free-vue-admin-template-theme')

const me = () => {
  updateMe(store, true)
}

const toggleColor = () => {
  colorMode.value !== 'dark' ? setColorMode('dark') : setColorMode('light')
  colorMode.value === 'dark' ? document.documentElement.classList.add('dark') : document.documentElement.classList.remove('dark')
}

</script>

<template>
  <footer class="container p-4">
    <div>
    </div>
    <div class="ms-auto d-flex flex-row align-items-center gap-3">
      <small role="button" @click="toggleColor" class="small">
        <i v-if="colorMode === 'dark'" class="bi bi-moon-stars"></i>
        <i v-else class="bi bi-brightness-high"></i>
      </small>
      <small class="text-muted" @click="me" role="button">v. {{ version }}</small>
      <i class="bi bi-box-arrow-right exit-btn" role="button" @click="logout"></i>
      <router-link to="/platform/dashboard" class="small text-decoration-none text-secondary">
        {{ weekNumByDate(nowUtc().toDate()) }} week,
        {{ prettyDt(nowTz(), "DD HH:mm", true, 'UTC') }} UTC
      </router-link>
    </div>
  </footer>
</template>
